
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/club/[club]/org",
      function () {
        return require("private-next-pages/club/[club]/org.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/club/[club]/org"])
      });
    }
  